"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function Overview() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section className="relative w-full overflow-hidden bg-background flex items-center justify-center">
      {}
      <div ref={parallaxRef} className="absolute inset-0 z-0" style={{
      transform: `translateY(${scrollY * 0.05}px)`,
      willChange: "transform"
    }}>
        
      </div>

      {}
      <div ref={contentRef} className={`glass-effect relative z-10 max-w-7xl mx-auto transform px-8 py-10 md:px-12 md:py-12 text-center shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] my-16 md:my-20 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
      backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.4)), url(https://famous-marmoset.10web.cloud/wp-content/uploads/2025/12/manufacturing_scale_up_for_food_tech.webp)`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
        {}
        <div className="relative z-10">
          <h1 className="mb-6 text-5xl font-bold leading-tight text-white">
            Turnkey, Brand-Ready Product Creation
          </h1>
          <p className="mb-0 text-lg text-white/90 md:text-xl">
            We help brands accelerate growth through fully developed white-label and private-label products supported by deep technical expertise.
          </p>
        </div>
      </div>
    </section>;
}